
<div class="header_sec">
  <div class="custom_sd_btn">
    <figure class="logo_img">
      <img [src]="assetsConst.logo" alt="logo" />
    </figure>
    <!-- <h1>LOGO</h1> -->
    <p-button class="close_btn" (onClick)="sidebarOnOff()" icon="pi pi-align-left"></p-button>
  </div>
  <div class="rt_nv">
    <div class="lt"></div>
    <ul class="rt">
      <li>
        <button class="bell" (click)="op.toggle($event)">
          <img [src]="assetsConst.bellIcon" alt="Icon">
        </button>

        <p-overlayPanel #op>
          <div class="listing_not dropdown-content">
            <div class="d_flx">
              <h2>{{"Notifications" | translate}}</h2><button (click)="navigateToNotifications(op)" class="see_link">{{"SeeAll" | translate}}</button>

            </div>
            <ul class="not_list">
              @if (notificationList() && notificationList().length) {
                @for (item of notificationList(); track $index) {
                  <li class="ntf-list">
                    <!-- <figure><img alt="profile" src="assets/images/placeholdr_user.svg"></figure> -->
                    <div class="ntf_dt">
                      <h3>{{item.notification.title |langValue: currentLang|| '---'}} 
                        <!-- <span class="ntf_tym">1 day ago</span> -->
                        </h3>
                      <p>{{item.notification.message | langValue: currentLang|| '---'}}</p>
                    </div>
                  </li>
                }
              } @else {
                <td  class="text-center py-4">
                  {{ 'noRecordFound' | translate }}
                </td>
              }
            </ul>
          </div>
        </p-overlayPanel>

      </li>
      <li>
        <p-button
          class="languageBtn"
          (click)="languageMenu.toggle($event)"
          [label]="currentLang"
          icon="pi pi-angle-down"
          iconPos="right"
        ></p-button>
        <p-menu #languageMenu [model]="items" [popup]="true"></p-menu>
      </li>
      <li>

        @if(profile){
        <figure class="hd_profile" routerLink="/profile">
          <img [src]="profile.profile_picture.media_url ? profile.profile_picture.media_url : assetsConst.userPlaceholder" alt="Profile" />
          <figcaption><strong>{{profile.full_name}}</strong> <span>{{'Admin' | translate}}</span></figcaption>
        </figure>
        }


      </li>
    </ul>
  </div>
</div>